import { ajaxActions } from 'common/ajax/store.js';
import { basePath } from 'common/config.js';

export const RECEIVED_ACCOUNTS_OVERVIEW = 'RECEIVED_ACCOUNTS_OVERVIEW';

const initialState = {
  accounts: null,
};

export const actionCreators = {
  getLinkedAccounts: (handleRedirect) => async (dispatch) => {
    let url = `${basePath}/api/user/accounts`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'GET',
        (result) => {
          dispatch({ type: RECEIVED_ACCOUNTS_OVERVIEW, result: result });
          handleRedirect && handleRedirect(result);
        },
        null
      )
    );
  },
};

export const reducer = (state = initialState, action) => {
  if (action.type === RECEIVED_ACCOUNTS_OVERVIEW) {
    return {
      ...state,
      accounts: action.result,
    };
  }
  return state;
};
